// extracted by mini-css-extract-plugin
module.exports = {"loading_text":"LoadingMap_loading_text__1HGdt","loading_inner_text":"LoadingMap_loading_inner_text__2ysXQ","content_wrapper_text":"LoadingMap_content_wrapper_text__2dlpm"};